import React from "react";
import { formatAddress } from "../../utils/utils";
import { CreatorAvatar, CreatorCardWrapper, CreatorInfo, CreatorNumber } from "./CreatorCard.styled";
import ton_logo from "../../assets/img/ton-logo.svg";

export const CreatorCard = ({ creator, number }) => {
  return (
    <CreatorCardWrapper to={`/marketplace/creators/${creator.id}`}>
      <CreatorNumber>{number + 1}</CreatorNumber>
      <CreatorAvatar>
        <img src={creator?.ava} alt='avatar' />
      </CreatorAvatar>
      <CreatorInfo>
        <h5>{creator?.name ? creator?.name : formatAddress(creator?.wallet)}</h5>
        <span>
          <img src={ton_logo} />
          {creator?.balance} TON
        </span>
      </CreatorInfo>
    </CreatorCardWrapper>
  );
};
